"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatForTestId = void 0;

var formatForTestId = function formatForTestId(name) {
  return name.replace(/[^a-zA-Z0-9\s]/g, '').replace(/[\s]+/g, '-').toLowerCase();
};

exports.formatForTestId = formatForTestId;
//# sourceMappingURL=test-id.js.map